import { render } from "./BModal.vue?vue&type=template&id=5fcc0194&ts=true"
import script from "./BModal.vue?vue&type=script&lang=ts"
export * from "./BModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__